import { InformationBox, Shimmer } from '@pukka/ui-components';

interface EwalletInformationBoxProps {
  readonly isLoading: boolean;
  readonly isTrial?: boolean;
}

function EwalletInformationBox({ isLoading, isTrial }: EwalletInformationBoxProps) {
  if (isLoading) {
    return <Shimmer size="xxl" className="h-14 w-full" />;
  }

  if (isTrial) {
    return (
      <InformationBox icon="info" variant="warning" size="lg">
        Your business is still in trial mode
      </InformationBox>
    );
  }

  return (
    <InformationBox icon="info" variant="secondary" size="lg">
      Registration will be processed in 14 working days. Status will updated automatically.
    </InformationBox>
  );
}

export { EwalletInformationBox };
